import React from 'react';
import CreationRecordList from './CreationRecordList';
import CreationRecordModals from './CreationRecordModals';
import { EmptyState, FilterTabs, LoadingState, RecordHeader } from './CreationRecordChrome';

export default function CreationRecordView({
  actions,
  filteredRecords,
  filter,
  loading,
  modalProps,
  navigate,
  setFilter,
  stats,
  t,
  typeLabel,
  user,
}) {
  if (loading) return <CreationRecordShell><LoadingState t={t} /></CreationRecordShell>;
  return (
    <CreationRecordShell>
      <RecordHeader t={t} />
      <FilterTabs filter={filter} stats={stats} t={t} onFilter={setFilter} onRefresh={actions.refresh} />
      <CreationRecordList records={filteredRecords} t={t} typeLabel={typeLabel} actions={actions} />
      {filteredRecords.length === 0 && <EmptyState t={t} onCreate={() => navigate('/ai-workbench')} />}
      <CreationRecordModals {...modalProps} {...modalHandlers(actions)} by={user?.username || user?.name || user?.email || ''} t={t} getTypeLabel={typeLabel} />
    </CreationRecordShell>
  );
}

function CreationRecordShell({ children }) {
  return (
    <div className="creation-record">
      <div className="creation-record-container">{children}</div>
    </div>
  );
}

function modalHandlers(actions) {
  return {
    onCloseAudio: actions.closeAudio,
    onCloseLyrics: actions.closeLyrics,
    onCloseShare: actions.closeShare,
    onCloseVideo: actions.closeVideo,
  };
}
